package br.com.vvrefeicoes.portal.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.navigation.compose.NavHost
import androidx.navigation.compose.composable
import androidx.navigation.compose.rememberNavController
import androidx.navigation.toRoute
import br.com.vvrefeicoes.portal.core.ui.components.LocalOpenPrivacyPolicy
import br.com.vvrefeicoes.portal.feature.auth.forgotPassword.ForgotPasswordScreen
import br.com.vvrefeicoes.portal.feature.auth.login.LoginScreen
import br.com.vvrefeicoes.portal.feature.legal.PrivacyPolicyScreen
import br.com.vvrefeicoes.portal.feature.monitor.PublicMonitorScreen

private const val PASSWORD_CHANGED_KEY = "passwordChanged"
private const val FORGOT_PASSWORD_EMAIL_KEY = "forgotPasswordEmail"

@Composable
fun AuthNavHost() {
    val navController = rememberNavController()
    SyncNavigationWithUrl(navController)
    CompositionLocalProvider(LocalOpenPrivacyPolicy provides { navController.navigate(PrivacyPolicyRoute) }) {
        NavHost(
            navController = navController,
            startDestination = LoginRoute,
        ) {
            composable<LoginRoute> { entry ->
                val showPasswordChangedBanner =
                    remember {
                        mutableStateOf(entry.savedStateHandle.remove<Boolean>(PASSWORD_CHANGED_KEY) == true)
                    }
                LoginScreen(
                    onForgotPassword = { email ->
                        navController.navigate(ForgotPasswordRoute)
                        navController.currentBackStackEntry
                            ?.savedStateHandle
                            ?.set(FORGOT_PASSWORD_EMAIL_KEY, email)
                    },
                    showPasswordChangedBanner = showPasswordChangedBanner.value,
                )
            }
            composable<ForgotPasswordRoute> { entry ->
                val initialEmail = entry.savedStateHandle.get<String>(FORGOT_PASSWORD_EMAIL_KEY).orEmpty()
                ForgotPasswordScreen(
                    onBack = { navController.popBackStack() },
                    onPasswordChanged = {
                        navController.previousBackStackEntry?.savedStateHandle?.set(PASSWORD_CHANGED_KEY, true)
                        navController.popBackStack()
                    },
                    initialEmail = initialEmail,
                )
            }
            composable<PrivacyPolicyRoute> {
                PrivacyPolicyScreen(onBack = { navController.popBackStack() })
            }
            composable<PublicMonitorRoute> { entry ->
                PublicMonitorScreen(entry.toRoute<PublicMonitorRoute>().code)
            }
        }
    }
}
